module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/12322db7eea256919812fe2127f2d580.svg";